import classNames from "~/utils/classNames"
import React from "react"
import PortalHoverTip from "~/components/ui/PortalHoverTip"
import { ExclamationCircleIcon } from "@heroicons/react/24/outline"

const CouponsSelector = ({
  value,
  setValue,
  options,
  label,
}: {
  value: string
  setValue: (v: { label: string; value: any; tooltip?: string }) => void
  options: { label: string; value: any, tooltip?: string }[]
  label: string
}) => {
  return (
    <div className="w-full">
      <label htmlFor="name" className="block font-semibold text-md text-gray-900 mb-0.5">
        {label}
      </label>
      <div className="grid grid-cols-2 gap-x-3 gap-y-2">
        {options.map((type) => {
          return (
            <div
              key={type.value}
              className={classNames(
                "cursor-pointer transition-colors rounded-lg py-1.5 px-4 flex justify-between",
                value === type.value
                  ? "font-semibold border-2 border-green-500 text-green-600 hover:cursor-default"
                  : "border border-gray-350 hover:bg-gray-100 hover:border-gray-400 hover:text-black text-gray-600",
              )}
              onClick={() => {
                setValue(type)
              }}
            >
              {type.label}
              {!!type?.tooltip?.length && (
                <PortalHoverTip content={type?.tooltip} className="flex items-center">
                  <ExclamationCircleIcon className="w-4 h-4 ml-auto" />
                </PortalHoverTip>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CouponsSelector
